export default "__VITE_ASSET__3833ec79__"